import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

interface CachedBadgeProps {
	cachedAt: string | null;
}

function formatRelative(isoDate: string): string {
	const diff = Date.now() - new Date(isoDate).getTime();
	const minutes = Math.floor(diff / 60000);
	if (minutes < 1) return 'hace menos de 1 min';
	if (minutes < 60) return `hace ${minutes} min`;
	const hours = Math.floor(minutes / 60);
	if (hours < 24) return `hace ${hours}h`;
	return `hace ${Math.floor(hours / 24)}d`;
}

export function CachedBadge({ cachedAt }: CachedBadgeProps): JSX.Element | null {
	if (!cachedAt) return null;

	const label = `Actualizado ${formatRelative(cachedAt)}`;

	return (
		<Tooltip title={`Datos cacheados: ${new Date(cachedAt).toLocaleString('es')}`}>
			<Typography
				variant="caption"
				color="text.secondary"
				sx={{ display: 'flex', alignItems: 'center', gap: 0.4, cursor: 'default' }}
			>
				<AccessTimeIcon sx={{ fontSize: 12 }} />
				{label}
			</Typography>
		</Tooltip>
	);
}
